import { render, staticRenderFns } from "./EventOverviewTab.vue?vue&type=template&id=643942d7&scoped=true&"
import script from "./EventOverviewTab.vue?vue&type=script&lang=js&"
export * from "./EventOverviewTab.vue?vue&type=script&lang=js&"
import style0 from "./EventOverviewTab.vue?vue&type=style&index=0&id=643942d7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "643942d7",
  null
  
)

export default component.exports